import {handleActions} from 'redux-actions';
import {Record, Map, List} from 'immutable';

import * as AccountItemActions from 'web-app/react/entities/account-items/actions';
import * as AccountItemMoveModalActions from 'web-app/react/modals-container/account-item-move/actions';

import * as Actions from './actions';

const AddPayment = Record({
    show: false,
    billPayerId: null,
    institutionId: undefined,
    settings: undefined,
    itemId: null,
    relationId: null,
    invoiceId: null,
    fetchingData: true,
    deletingData: false,
    readOnly: false,
    accountItems: Map(),
    accountItemIds: List(),
    invoices: Map(),
    invoiceIds: List(),
    balance: null,
    fetchingBalanceData: false,
});

const paymentFailed = state => {
    return state.merge({
        fetchingData: false,
        deletingData: false,
    });
};

const paymentSucceeded = () => new AddPayment();

export default handleActions(
    {
        [Actions.fetchAll.type]: state => state.merge({fetchingData: true}),
        [Actions.fetchAllSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingData: false,
                invoices: payload.invoices.reduce((map, item) => {
                    return map.set(item.id, item);
                }, Map()),
                invoiceIds: payload.invoices.map(item => item.id),
            }),
        [Actions.fetchAllFailed.type]: state => state.merge({fetchingData: false}),

        [Actions.fetchBalance.type]: state => state.merge({fetchingBalanceData: true}),
        [Actions.fetchBalanceSuccess.type]: (state, {payload}) =>
            state.merge({
                fetchingBalanceData: false,
                accountItems: payload.accountItems.reduce((map, item) => {
                    return map.set(item.id, item);
                }, Map()),
                accountItemIds: payload.accountItems.map(item => item.id),
                balance: payload.balance,
            }),
        [Actions.fetchBalanceFailed.type]: state => state.merge({fetchingBalanceData: false}),

        [Actions.createPayment.type]: state => state.merge({fetchingData: true}),
        [Actions.updatePayment.type]: state => state.merge({fetchingData: true}),
        [Actions.confirmPayment.type]: state => state.merge({fetchingData: true}),
        [Actions.denyPayment.type]: state => state.merge({deletingData: true}),
        [AccountItemActions.createPayment.type]: state => state.merge({fetchingData: true}),
        [AccountItemActions.updatePayment.type]: state => state.merge({fetchingData: true}),
        [AccountItemActions.deletePayment.type]: state => state.merge({deletingData: true}),
        [Actions.createPaymentSuccess.type]: paymentSucceeded,
        [Actions.updatePaymentSuccess.type]: paymentSucceeded,
        [Actions.confirmPaymentSuccess.type]: paymentSucceeded,
        [Actions.denyPaymentSuccess.type]: paymentSucceeded,
        [AccountItemActions.createPaymentSuccess.type]: paymentSucceeded,
        [AccountItemActions.updatePaymentSuccess.type]: paymentSucceeded,
        [AccountItemActions.deletePaymentSuccess.type]: paymentSucceeded,
        [Actions.createPaymentFailed.type]: paymentFailed,
        [Actions.updatePaymentFailed.type]: paymentFailed,
        [Actions.confirmPaymentFailed.type]: paymentFailed,
        [Actions.denyPaymentFailed.type]: paymentFailed,
        [Actions.denyPaymentAborted.type]: paymentFailed,
        [AccountItemActions.createPaymentFailed.type]: paymentFailed,
        [AccountItemActions.updatePaymentFailed.type]: paymentFailed,
        [AccountItemActions.deletePaymentFailed.type]: paymentFailed,
        [AccountItemActions.deletePaymentAborted.type]: paymentFailed,
        [Actions.showPaymentModal.type]: (state, action) => {
            return state.merge({
                show: true,
                billPayerId: action.payload.billPayerId,
                settings: action.payload.settings,
                relationId: action.payload.relationId,
                invoiceId: action.payload.invoiceId,
                institutionId: action.payload.institutionId,
                itemId: action.payload.itemId,
                readOnly: action.payload.readOnly,
            });
        },
        [Actions.showPaymentModalFromChild.type]: (state, {payload}) => {
            return state.merge({
                show: true,
                billPayerId: payload.payer.billPayerId,
                settings: payload.settings,
                relationId: payload.relationId,
                invoiceId: payload.invoiceId,
                institutionId: payload.institutionId,
                itemId: payload.itemId,
                readOnly: payload.readOnly,
            });
        },
        [Actions.hidePaymentModal.type]: () => new AddPayment(),
        [AccountItemMoveModalActions.movePaymentSuccess.type]: () => new AddPayment(),
    },
    new AddPayment(),
);
